// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

export default function GridSettingDialog(props) {
  const { open, onClose, columnDefs, columnState, onUpdateState, onRestoreDefault } = props;


  const handleCloseClick = () => {
    onClose && onClose();
  }

  const handleToggle = (aColState) => {
    // console.log(' GridSettingDialog ~ aColState:', aColState);

    const newState = columnState.map(s => {
      if (s.colId === aColState.colId) {
        return {
          ...s,
          hide: !s.hide,
        }
      } else {
        return s
      }
    })
    // console.log(' GridSettingDialog ~ newState:', newState);

    onUpdateState && onUpdateState(newState);

  };

  const handleDefaultClick = () => {

    onRestoreDefault && onRestoreDefault();

  };

  // Exclude "FileExt" setting
  // const filteredColStateList = columnState.filter(s => s.colId !== 'FileExt');
  const filteredColStateList = columnState.filter(s => ['FileExt','CheckOut'].includes(s.colId) === false);


  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%' } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>Columns</DialogTitle>
      <DialogContent>
        <Grid container spacing={{ xs: 1 }}  >
          <Grid item xs={12}>

          </Grid>
          <Grid item xs={12}>
            <List sx={{ width: '100%' }}>
              {filteredColStateList.map((s) => {
                const colDef = columnDefs.find(c => c.field === s.colId);

                return (
                  <ListItem
                    key={s.colId}
                    style={{ height: "35px" }}
                  // dense
                  >
                    <ListItemButton
                      role={undefined}
                      onClick={() => handleToggle(s)}
                      // disabled={s.colId === 'FileExt'}
                      dense>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"

                          checked={!s.hide}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': s.colId }}
                          style={{ height: "20px" }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        id={`item_${s.colId}`}
                        primary={`${colDef ? colDef.headerName : s.colId}`} />
                    </ListItemButton>
                  </ListItem>
                )

              })}

            </List>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleDefaultClick} >Restore Default</Button>
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

GridSettingDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  columnDefs: PropTypes.array,
  columnState: PropTypes.array,
  onUpdateState: PropTypes.func,
  onRestoreDefault: PropTypes.func,
};